import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { CampaignSelector } from './CampaignSelector';
const formatCurrency = (value: number) => value.toLocaleString('en-US');
export function EdgePricing() {
  const [campaignMode, setCampaignMode] = useState(1);
  const isPartial = campaignMode === 0;
  const campaigns = isPartial ? 1 : campaignMode;
  const buildFee = 3000 + (isPartial ? 0 : 1000 * (campaignMode - 1));
  const systemFee = 1500;
  const campaignFee = isPartial ? 750 : 1000 * campaigns;
  const monthlyTotal = systemFee + campaignFee;
  return <section className="pt-4 pb-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-61" data-mp="30as2h5343ef2">
      <CampaignSelector mode={campaignMode} onChange={setCampaignMode} accent="slate" data-id="element-62" data-mp="356gwkswd433z" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-63" data-mp="3a51x6tfj0osy">
        <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl relative overflow-hidden" data-id="element-64" data-mp="kgrkgnn1mvez">
          <div className="mb-4" data-id="element-65" data-mp="pfm7y2vyh85f">
            <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-66" data-mp="piql3prefe88">
              Build and Implementation (One-Time)
            </div>
            <div className="text-3xl font-bold text-white" data-id="element-67" data-mp="mddyle4yhfz1">
              ${formatCurrency(buildFee)}
            </div>
            <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-68" data-mp="hbok1oiiyk67">
              {['Company and opportunity profiling', 'Custom ATS, workflows, and job board integrations', 'Landing page and candidate application flow', 'Campaign messaging and ad creative', 'Pre-launch system setup and stress test', 'Access to HIRE’s LMS best-practices library', 'Interview process training', 'Three Sales School tickets'].map(point => <li key={point} className="flex items-start" data-id="element-69" data-mp="3ksn8eat00uqh">
                  <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-70" data-mp="3fv59zeclxxwq" />
                  <span className="text-slate-400 text-sm leading-snug" data-id="element-71" data-mp="3679f0ffo01ed">
                    {point}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="bg-slate-900/40 border border-slate-600 p-6 rounded-xl relative" data-id="element-72" data-mp="2x6uon1nufw40">
          <div className="absolute top-0 left-0 w-full h-1 bg-slate-500 rounded-t-xl" data-id="element-73" data-mp="3186k3ntefbk4" />
          <div className="mb-4" data-id="element-74" data-mp="319zpz0w6trr2">
            <div className="text-xs text-slate-400 uppercase tracking-widest mb-2" data-id="element-75" data-mp="3ox91cuk4f2e3">
              Total Monthly
            </div>
            <div className="text-4xl font-bold text-white mb-1" data-id="element-76" data-mp="3twc4g9gjiyjf">
              ${formatCurrency(monthlyTotal)}
            </div>
            <div className="text-sm text-slate-500 mb-6" data-id="element-77" data-mp="3g3mho2t6tpl9">/ month</div>

            <div className="space-y-3 pt-4 border-t border-slate-800/50" data-id="element-78" data-mp="3k5hgn0nnbqvv">
              <div className="flex justify-between text-sm" data-id="element-79" data-mp="bqz70ui243a5">
                <span className="text-slate-400" data-id="element-80" data-mp="ghxlrpnectba">System Fee</span>
                <span className="text-white font-medium" data-id="element-81" data-mp="gjik7qcu0wef">
                  ${formatCurrency(systemFee)}
                </span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-82" data-mp="1w9jbhxdnjcb7">
                <span className="text-slate-400" data-id="element-83" data-mp="1w8zxgrr4h82g">
                  {isPartial ? 'Partial Campaign' : campaigns === 1 ? 'Full Campaign' : `Full Campaigns (×${campaigns})`}
                </span>
                <span className="text-white font-medium" data-id="element-84" data-mp="1iaa15ec4ncf5">
                  ${formatCurrency(campaignFee)}
                </span>
              </div>
            </div>

            <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-85" data-mp="1s87mnu2lqv42">
              {['Active job board management and campaign optimization', 'Applicant screening and pre-qualification', 'Candidate handoff to your internal team', 'Multi-market coordination and reporting', 'Ongoing system support and performance visibility'].map(point => <li key={point} className="flex items-start" data-id="element-86" data-mp="188prq5l9z8hq">
                  <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-87" data-mp="1d6r8gjv8avq1" />
                  <span className="text-slate-400 text-sm leading-snug" data-id="element-88" data-mp="1h71oyqgnd4j5">
                    {point}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-89" data-mp="1r4fv9x8uwcxq">
          <div className="mb-4" data-id="element-90" data-mp="1w425ryxavf2u">
            <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-4" data-id="element-91" data-mp="1w30vvxs0symp">
              Sales School Tickets
            </div>
            <div className="flex items-baseline mb-2" data-id="element-92" data-mp="20xodrdsiqusb">
              <span className="text-3xl font-bold text-white" data-id="element-93" data-mp="24vm26eegtcun">$200</span>
              <span className="text-slate-400 ml-2 text-sm" data-id="element-94" data-mp="29wicpatbnx91">per ticket</span>
            </div>
            <p className="mt-5 pt-4 border-t border-slate-800/50 text-slate-400 text-sm leading-snug" data-id="element-95" data-mp="2eujza5pyiep9">
              Sales School tickets are purchased separately based on the number
              of attendees, up to a $5,000 monthly maximum.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-8 p-6 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg max-w-3xl mx-auto" data-id="element-96" data-mp="2f0au4xg8tv8l">
        <p className="text-[#7FE0C3] text-center font-medium" data-id="element-97" data-mp="2b00nrjojh2t7">
          Ad spend is paid directly to the job platforms and is separate from
          HIRE&apos;s fees.
        </p>
      </div>
    </section>;
}